import axios from '@plugins/axios'
import store from '@state/store'
import config from '@src/app.config'
const env = config.env
const appConfig = config[env]

export const state = {
  cached: {},
  thirdparties: {
    results: []
  },
  loadingThirdparties: false,
}

export const getters = {
  thirdparties: state => state.thirdparties,
  loadingThirdparties: state => state.loadingThirdparties,
}

export const mutations = {
  CACHE_THIRDPARTY(state, thirdparty) {
    state.cached = thirdparty
  },
  SET_THIRDPARTIES(state, data) {
    state.thirdparties = data
  },
  SET_LOADING(state, loading) {
    if (loading !== false) {
      state.loadingThirdparties = true
      store.dispatch('utils/loaderMessage', loading)
    } else {
      state.loadingThirdparties = false
      store.dispatch('utils/loaderMessage', '')
    }
  },
}

export const actions = {
  createThirdparty({ commit, dispatch }, payload) {
    commit('SET_LOADING', 'Creando tercero')
    axios.post(appConfig.server_url + '/company/thirdparty/', payload)
      .then(resp => {
        dispatch('fetchThirdparties', payload.query)
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Cliente creado correctamente.' })
        commit('SET_LOADING', false)
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Cliente no fue creado correctamente.' })
        commit('SET_LOADING', false)
      })
  },
  updateThirdparty({ commit, dispatch }, payload) {
    commit('SET_LOADING', 'Actualizando tercero')
    axios.put(payload.url, payload)
      .then(resp => {
        dispatch('fetchThirdparties', payload.query)
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Cliente actualizado correctamente.' })
        commit('SET_LOADING', false)
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Cliente no fue actualizado correctamente.' })
        commit('SET_LOADING', false)
      })
  },
  deleteThirdparty({ commit, dispatch }, thirdpartyURL) {
    commit('SET_LOADING', 'Eliminando tercero')
    axios.delete(thirdpartyURL)
      .then(resp => {
        dispatch('fetchThirdparties')
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Cliente eliminado correctamente.' })
        commit('SET_LOADING', false)
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Cliente no fue eliminado correctamente.' })
        commit('SET_LOADING', false)
      })
  },
  fetchThirdparties({ commit }, query) {
    commit('SET_LOADING', 'Consultando terceros')
    axios.get(appConfig.server_url + `/company/thirdparty/?` + query)
      .then(resp => {
        if (resp.status === 200) {
          commit('SET_THIRDPARTIES', resp.data)
        }
        commit('SET_LOADING', false)
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error consultando terceros' })
        commit('SET_LOADING', false)
      })
  },
  setThirdpartyFile({ commit, dispatch }, { url, formData }) {
    let promise = null
    promise = axios.put(`${url}set_file/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    commit('SET_LOADING', 'Subiendo archivo...')
    return promise.then(
      (response) => {
        dispatch('fetchThirdparties')
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Archivo subido correctamente' })
        return response.data
      }
    ).catch(() => {
      store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error subiendo archivo de tercero' })
      commit('SET_LOADING', false)
    })
  },

  fetchThirdPartyAssessments(_, queryParams = '') {
    const serverUrl = appConfig.server_url
    return axios.get(`${serverUrl}/company/thirdparty/get_assessments/${queryParams}`)
  }
}